import { NgModule } from '@angular/core';
import { PrivacyComponent } from './privacy.component';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../../../../core/modules/shared.module';

const routes = [
  {
    path: 'pages/privacy',
    component: PrivacyComponent
  }
];

@NgModule({
  declarations: [
    PrivacyComponent
  ],
  imports : [
    SharedModule,
    CommonModule,
    RouterModule.forChild(routes)
  ]
})

export class PrivacyModule{

}
